import React, { useCallback, useEffect, useRef } from 'react'
import { useChatDispatch, useChatState } from './AgentProvider'
import Prompt from '../../../components/Chat/Prompt'
import {
  GetMessageHistoriesQuery,
  GetMessageHistoriesQueryVariables,
} from 'app/javascript/components/graphql'
import { GET_MESSAGE_HISTORIES } from '../../../graphql/queries/message_thread'
import Message from '../../../components/Chat/Message'
import { useQuery } from '@apollo/client'

const Chat = () => {
  const divRef = useRef<HTMLDivElement>(null)
  const { agent, threadUuid, isQuerying, messages, streamedResponse } = useChatState()
  const { setMessages } = useChatDispatch()

  const scrollToBottom = useCallback(() => {
    const element = divRef.current
    if (element) {
      element.scrollTop = element.scrollHeight
    }
  }, [divRef.current])

  useEffect(() => {
    scrollToBottom()
  }, [messages, isQuerying, divRef.current])

  const { data: messageHistoryData } = useQuery<
    GetMessageHistoriesQuery,
    GetMessageHistoriesQueryVariables
  >(GET_MESSAGE_HISTORIES, {
    // Only execute the query if the thread_uuid exists.
    skip: !threadUuid,
    variables: {
      uuid: threadUuid,
    },
    fetchPolicy: 'network-only',
  })

  useEffect(() => {
    const messageHistory = messageHistoryData?.getMessageHistories || []
    if (messageHistory.length === 0) {
      return
    }

    const messageList = messageHistory.map((message) => {
      return {
        content: message.message,
        actor: message.actor,
        uuid: message.uuid,
        createdAt: message.createdAt,
      }
    })
    setMessages(messageList)
  }, [messageHistoryData])

  return (
    <>
      <div ref={divRef} className="flex-grow overflow-y-auto">
        <ul role="list" className="space-y-6 p-8 mb-12 mr-10">
          {messages.map((message, messageIndex: number) => (
            <Message agentUuid={agent.uuid} message={message} key={messageIndex} />
          ))}

          {(isQuerying || streamedResponse) && (
            <Message
              agentUuid={agent.uuid}
              message={{
                content: [{ type: 'text', value: streamedResponse }],
                actor: 'system',
                createdAt: null,
              }}
              showVoting={false}
              isStreaming={true}
            />
          )}
        </ul>
      </div>

      <div className="flex-shrink-0 p-4 px-10 pb-10 flex justify-center">
        <div className="w-full flex justify-center items-center max-w-5xl">
          <Prompt />
        </div>
      </div>
    </>
  )
}
export default Chat
